module.exports = __webpack_public_path__ + "img/IMG_9928_L.c48e42d3.webp";